// Верхнее меню — сегментированный «пилюльный» переключатель разделов:
// светлая капсула-подложка, активный раздел закрашен фирменным градиентом.
const NAV_ITEMS = [
    {key: 'video', label: 'Видео', href: '/'},
    {key: 'zvonki', label: 'Звонки', href: '/zvonki/'},
    // На узких экранах капсула не вмещает «Мои заказы» — там короткая форма.
    {key: 'orders', label: 'Мои заказы', shortLabel: 'Заказы', href: '/orders'},
    {key: 'blog', label: 'Блог', href: '/blog/'},
];

function activeKey(pathname) {
    if (pathname.startsWith('/zvonki')) return 'zvonki';
    if (pathname.startsWith('/orders')) return 'orders';
    if (pathname.startsWith('/blog')) return 'blog';
    if (pathname === '/' || pathname === '') return 'video';
    return null;
}

export default function Header({onHomeClick}) {
    const pathname = window.location.pathname;
    const isHome = pathname === '/' || pathname === '';
    const active = activeKey(pathname);

    // На главной ссылка на главную не перезагружает страницу, а сбрасывает состояние.
    const handleHomeClick = (e) => {
        if (isHome && onHomeClick) {
            e.preventDefault();
            onHomeClick();
        }
    };

    return (
        <div
            className="w-full max-w-[1110px] mx-auto px-4 py-4 flex flex-col gap-3 md:flex-row md:justify-between md:items-center">
            <a
                href="/"
                onClick={handleHomeClick}
                className="flex flex-col items-start hover:opacity-80 transition"
            >
                <span className="text-2xl font-bold text-brand-dark">selebrus<span className="text-brand-red">.</span><span className="text-brand-dark/50">ru</span></span>
                <span className="text-[16px] text-brand-dark/50" style={{fontFamily: 'Poppins, sans-serif'}}>сервис поздравлен<span className="text-[20px] text-brand-red">ИИ</span>й</span>
            </a>

            <nav className="flex items-center gap-0.5 md:gap-1 p-1 bg-brand-gray rounded-full self-stretch md:self-auto max-w-full overflow-x-auto no-scrollbar">
                {NAV_ITEMS.map(item => {
                    const isActive = item.key === active;
                    return (
                        <a
                            key={item.key}
                            href={item.href}
                            onClick={item.href === '/' ? handleHomeClick : undefined}
                            aria-current={isActive ? 'page' : undefined}
                            className={`flex-1 md:flex-none text-center whitespace-nowrap px-3 md:px-6 py-2 md:py-2.5 rounded-full text-sm md:text-lg font-medium tracking-[-0.18px] transition ${
                                isActive
                                    ? 'bg-gradient-brand text-white shadow-[0_4px_12px_rgba(255,89,89,0.35)]'
                                    : 'text-brand-dark hover:text-brand-red'
                            }`}
                        >
                            {item.shortLabel ? (
                                <>
                                    <span className="md:hidden">{item.shortLabel}</span>
                                    <span className="hidden md:inline">{item.label}</span>
                                </>
                            ) : item.label}
                        </a>
                    );
                })}
            </nav>
        </div>
    );
}
